const BattleCalc = require('../../BattleCalc');
const Q_how_many_nearby_enemies_BASE = require('../questions/Q_how_many_nearby_enemies_BASE');
const Q_state_of_best_target = require('./Q_state_of_best_target');
const Q_how_many_nearby_allies = require('./Q_how_many_nearby_allies');
const Q_any_enemies = require('./Q_any_enemies');

const DPSCloseDecision = function (actor, battleState, moveTowardsTree) {
  const node = new Q_how_many_nearby_enemies_BASE(actor, battleState);

  // branch indexes
  // const for zero is taken by ... well, zero (in the parent class)
  const ONE = 1;
  const TWO_OR_MORE = 2;

  node.branches[ONE] = new Q_state_of_best_target(actor, battleState);

  // we pass this a reference to the "state of best target" node, as an alternat in case no AOE abilities are equipped
  node.branches[TWO_OR_MORE] = new Q_how_many_nearby_allies(
    actor,
    battleState,
    node.branches[ONE]
  );

  node.branches[node.ZERO] = new Q_any_enemies(
    actor,
    battleState,
    moveTowardsTree
  );

  // if i'm a ranged_dps unit, skip this tree
  const actor_is_pure_ranged = BattleCalc.unitIsPureRanged(actor);

  node.query = function (static_target, force_dps_close = false) {
    if (
      actor_is_pure_ranged &&
      !force_dps_close &&
      !BattleCalc.getCondition(actor, 'enraged')
    )
      return null;

    const numNearby = this.calculateNearbyEnemies(2);

    if (numNearby > 1) {
      return this.branches[TWO_OR_MORE].query(static_target);
    } else if (numNearby > 0) {
      return this.branches[ONE].query(static_target);
    } else {
      const buff_decision = this.branches[node.ZERO].query();
      return buff_decision;
    }
  };

  return node;
};
module.exports = DPSCloseDecision;
